import authService from "@/services/AuthService";

import adminServices from "@/modules/hollymontt-admin/services/index";

const services = [authService, ...adminServices];

export default {
  get: name => services.find(s => s.name === name),
};
